﻿import { ContractStatus } from './types';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

const isValidDate = (value: Date) => !Number.isNaN(value.getTime());

export const formatCurrency = (
        value: number | null | undefined,
        locale: string | undefined = undefined,
        currency = 'EUR'
) => {
        if (value == null) {
                return null;
        }

        return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency
        }).format(value);
};

export const formatDate = (value: string | null | undefined) => {
        if (!value) {
                return null;
        }

        const date = new Date(value);
        if (!isValidDate(date)) {
                return value;
        }

        return date.toLocaleDateString();
};

export const formatDateTime = (value: string | null | undefined) => {
        if (!value) {
                return null;
        }

        const date = new Date(value);
        if (!isValidDate(date)) {
                return value;
        }

        return date.toLocaleString();
};

export const formatDateRange = (
        start: string | null | undefined,
        end: string | null | undefined
) => {
        const formattedStart = formatDate(start);
        const formattedEnd = formatDate(end);

        if (formattedStart === null && formattedEnd === null) {
                return null;
        }

        return `${formattedStart} → ${formattedEnd}`;
};

export const computeContractStatus = ({
        beginDate,
        endDate,
        isActive
}: {
        beginDate?: string | null;
        endDate?: string | null;
        isActive?: boolean;
}): ContractStatus => {
        if (isActive === false) {
                return 'suspended';
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (!beginDate || !endDate) {
                return 'scheduled';
        }

        const begin = new Date(beginDate);
        const end = new Date(endDate);

        if (!isValidDate(begin) || !isValidDate(end)) {
                return 'scheduled';
        }

        if (begin.getTime() > today.getTime()) {
                return 'scheduled';
        }

        if (end.getTime() < today.getTime()) {
                return 'expired';
        }

        const diffInMs = end.getTime() - today.getTime();
        const diffInDays = diffInMs / MS_PER_DAY;

        if (diffInDays <= 30) {
                return 'expiringSoon';
        }

        return 'active';
};
